/**
 * @file Analytics methods for google analytics and rudderstack
 */
const trackEvent = function (category, action, label, value) {
  gtag('event', action, {
    event_category: category,
    event_label: label,
    value,
  })
  if (window.rudderanalytics && window.$pepinUser) {
    const rudderEvent = category + '/' + action
    const rudderProperties = { label, value }
    const rudderOptions = { traits: window.$pepinUser }
    window.rudderanalytics.track(rudderEvent, rudderProperties, rudderOptions)
  }
}

export { trackEvent }
